<template>
  <van-field
      v-model="password"
      name="password"
      ref="password"
      :type="passwordType"
      :rules="[{ validator:passwordValidator}]"
      :placeholder="placeholder">
    <template #button>
      <van-image :src="require('@/assets/icons/v2/ic_login_eye.svg')" width="24px" height="24px"
          class="mr-3"
          @click="onClickEye"/>
    </template>
  </van-field>
</template>

<script>
export default {
  name: "PasswordField",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    confirmPasswordEnable: {
      type: Boolean,
      default: false
    },
    confirmPassword: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      passwordType: "password"
    };
  },

  computed: {
    password: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    onClickEye() {
      this.passwordType = this.passwordType === "text" ? "password" : "text";
    },
    passwordValidator(password) {
      if (password === "" || password.length < 6) {
        this.$refs.password.$el.style.borderColor = "red";
        return false;
      }
      if (this.confirmPasswordEnable) {
        if (password !== this.confirmPassword) {
          this.$refs.password.$el.style.borderColor = "red";
          return false;
        }
      }
      this.$refs.password.$el.style.borderColor = "#e8e8e8";
      return true;
    }
  }
};
</script>


<style scoped lang="less">

.van-cell {
  background: transparent;
  padding: 0px 12px;

}

.van-cell::after {
  border: none;
}

::v-deep .van-cell__value {
  border: 1px solid #E8E8E8;
  border-radius: 12px;
}

::v-deep .van-field__body {
  .van-field__button {
    display: flex;
    flex-direction: row;
    align-items: center;

  }
}


input {
  padding: 0 !important;
  border-radius: 0 !important;
}

.van-icon__image {
  width: 24px;
  height: 24px;
}
</style>